"use client";

import { c as _c } from "react/compiler-runtime";
import HeroSection from "@/layouts/webparts/hero/hero";
import HeroContact from "~/public/assets/contato/hero-contact.png";
import { ContactForm } from "./contact-form";
const contactItems = [{
  href: "https://api.whatsapp.com/send?phone=+5534996343519&text=Ol%C3%A1,%20gostaria%20de%20saber%20mais.",
  label: "Whatsapp",
  value: "(34) 99634-3519"
}, {
  href: "mailto:contato@flowlabtech.com.br",
  label: "Novos projetos",
  value: "contato@flowlabtech.com.br"
}, {
  href: "mailto:rh@flowlabtech.com.br",
  label: "Faça parte do time",
  value: "rh@flowlabtech.com.br"
}] as const;
export function ContactSection() {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <>Qual é o seu próximo<br /> projeto?</>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HeroSection tag="Contato" title={t0} description={<>Tire dúvidas, solicite orçamento, envie sugestões. <br /> Estamos à sua disposição.</>} containerWrapperClassName="max-md:pt-20" containerLeftClassName="md:pb-36" imageWrapClassName="max-md:max-w-80 max-lg:max-w-130 max-xl:max-w-160 absolute right-0 top-0" image={HeroContact} imageAlt={"Ilustra\xE7\xE3o da p\xE1gina de contato da Flowlab"} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="hidden md:block absolute -left-1.5 -top-1.5 size-3 border border-gray-300 bg-[#151515] z-40" />;
    t3 = <span className="hidden md:block absolute -right-1.5 -top-1.5 size-3 border border-gray-300 bg-[#151515] z-40" />;
    t4 = <span className="hidden md:block absolute -bottom-1.5 -left-1.5 size-3 border border-gray-300 bg-[#151515] z-40" />;
    t5 = <span className="hidden md:block absolute -bottom-1.5 -right-1.5 size-3 border border-gray-300 bg-[#151515] z-40" />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="max-w-100"><h2 className="title font-bold">Pronto para começar seu projeto?</h2></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col gap-12">{t6}<div className="space-y-10">{contactItems.map(_temp)}</div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <h2 className="text-xl font-bricolage">Envie sua mensagem</h2>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <>{t1}<section className="md:container-padding relative border-y border-gray-300 text-white" id="formulario-contato"><div className="container relative md:border-x md:border-gray-300 px-6 lg:px-18 3xl:px-24! py-18 md:py-28">{t2}{t3}{t4}{t5}<div className="flex flex-col lg:flex-row gap-12 justify-center lg:justify-between lg:gap-16">{t7}<div className="w-full md:max-w-105">{t8}<div className="mt-6"><ContactForm /></div></div></div></div></section></>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  return t9;
}
function _temp(t0) {
  const {
    href,
    label,
    value
  } = t0;
  return <div key={value}><p className="tag mb-1">{label}</p><a className="block w-fit text-sm md:text-base transition-all duration-300 ease-in-out hover:text-white/75" href={href}>{value}</a></div>;
}